import { validateUserToken } from '../services/userService';

export const validateLogin = async (navigate: Function) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    console.log("I am here 1");
    const loginKey = 'login_timestamp';
    const timestamp = localStorage.getItem(loginKey);
    if (!timestamp) {
        localStorage.clear();
        navigate('/login');
        return;
    }
    const loginTime = parseInt(timestamp, 10); // Convert string back to number
    const diffMs = Date.now() - loginTime;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    console.log(days)
    if(days > 5){
      localStorage.clear();
      navigate('/login');
    }
  } else {
    localStorage.clear();
    navigate('/login');
  }
};

export const validateLoginScreen = (navigate: Function) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    const loginKey = 'login_timestamp';
    const timestamp = localStorage.getItem(loginKey);
    if (!timestamp) {
        localStorage.clear();
        navigate('/login');
        return;
    }
    const loginTime = parseInt(timestamp, 10); // Convert string back to number
    const diffMs = Date.now() - loginTime;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    console.log(days)
    if(days > 5){
      localStorage.clear();
      navigate('/login');
    }
    navigate("/dashboard");
  } else {
    console.log('I am here 2');
  }
};